/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxUserFavouriteExchangesGetExecutedRatesParams
} from './schema'



/**
 * Get user favourite exchanges list
 */
export const utxUserFavouriteExchangesGetUserFavouriteExchangesList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/user-favourite-exchanges`,options
    );
  }


export const getUtxUserFavouriteExchangesGetUserFavouriteExchangesListQueryKey = () => [`/user-favourite-exchanges`];

    
export type UtxUserFavouriteExchangesGetUserFavouriteExchangesListQueryResult = NonNullable<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetUserFavouriteExchangesList>>>
export type UtxUserFavouriteExchangesGetUserFavouriteExchangesListQueryError = AxiosError<unknown>

export const useUtxUserFavouriteExchangesGetUserFavouriteExchangesList = <TData = Awaited<ReturnType<typeof utxUserFavouriteExchangesGetUserFavouriteExchangesList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetUserFavouriteExchangesList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUserFavouriteExchangesGetUserFavouriteExchangesListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetUserFavouriteExchangesList>>> = ({ signal }) => utxUserFavouriteExchangesGetUserFavouriteExchangesList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetUserFavouriteExchangesList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user favourite exchanges indicatives list
 */
export const utxUserFavouriteExchangesGetExecutedRates = (
    params: UtxUserFavouriteExchangesGetExecutedRatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/user-favourite-exchanges/executed-rates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUserFavouriteExchangesGetExecutedRatesQueryKey = (params: UtxUserFavouriteExchangesGetExecutedRatesParams,) => [`/user-favourite-exchanges/executed-rates`, ...(params ? [params]: [])];

    
export type UtxUserFavouriteExchangesGetExecutedRatesQueryResult = NonNullable<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetExecutedRates>>>
export type UtxUserFavouriteExchangesGetExecutedRatesQueryError = AxiosError<unknown>

export const useUtxUserFavouriteExchangesGetExecutedRates = <TData = Awaited<ReturnType<typeof utxUserFavouriteExchangesGetExecutedRates>>, TError = AxiosError<unknown>>(
 params: UtxUserFavouriteExchangesGetExecutedRatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetExecutedRates>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUserFavouriteExchangesGetExecutedRatesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetExecutedRates>>> = ({ signal }) => utxUserFavouriteExchangesGetExecutedRates(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUserFavouriteExchangesGetExecutedRates>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Client adds favourite ccy pair
 */
export const utxUserFavouriteExchangesClientAddFavouritePair = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/user-favourite-exchanges/add-favourite-pair`,undefined,options
    );
  }



    export type UtxUserFavouriteExchangesClientAddFavouritePairMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientAddFavouritePair>>>
    
    export type UtxUserFavouriteExchangesClientAddFavouritePairMutationError = AxiosError<unknown>

    export const useUtxUserFavouriteExchangesClientAddFavouritePair = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientAddFavouritePair>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientAddFavouritePair>>, TVariables> = () => {
          

          return  utxUserFavouriteExchangesClientAddFavouritePair(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientAddFavouritePair>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Client removes favourite ccy pair
 */
export const utxUserFavouriteExchangesClientRemoveFavouritePair = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/user-favourite-exchanges/remove-favourite-pair`,undefined,options
    );
  }



    export type UtxUserFavouriteExchangesClientRemoveFavouritePairMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientRemoveFavouritePair>>>
    
    export type UtxUserFavouriteExchangesClientRemoveFavouritePairMutationError = AxiosError<unknown>

    export const useUtxUserFavouriteExchangesClientRemoveFavouritePair = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientRemoveFavouritePair>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientRemoveFavouritePair>>, TVariables> = () => {
          

          return  utxUserFavouriteExchangesClientRemoveFavouritePair(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserFavouriteExchangesClientRemoveFavouritePair>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    